import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-stack-line"></i>
            焦点专题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            专题推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精心策划的影视专题，发现更多观影可能
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[16/9] object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-foreground-900 font-semibold text-sm md:text-base mb-1.5">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}